export const PASSWORD_REGEX = /^(?=.*[A-Z])(?=.*[0-9])/
export const PASSWORD_LENGTH = 7
export const PASSWORD_MAX_LENGTH = 32
export const PASSWORD_INPUT_MAX_CHARS = 100

export function getPasswordValidation () {
  return {
    minLength: PASSWORD_LENGTH,
    matchRegexp: PASSWORD_REGEX,
    maxLength: PASSWORD_MAX_LENGTH,
  }
}

export function getRepeatedPasswordValidation (validate) {
  return (
    `equalsField:${validate}`
  )
}

export function getPasswordStrength (value) {
  if (!value) {
    return 0
  }

  let progress = 0
  const valLength = value.length
  const hasUppercaseAndNumber = PASSWORD_REGEX.test(value)

  if (valLength < 8 && valLength > 1) {
    progress = valLength
  }
  if (valLength > PASSWORD_LENGTH) {
    progress = PASSWORD_LENGTH
  }
  if (hasUppercaseAndNumber) {
    /* eslint-disable no-plusplus */
    progress++
    /* eslint-enable no-plusplus */
  }
  return progress
}
